import { render, staticRenderFns } from "./ConfirmModal2.vue?vue&type=template&id=8effac48"
import script from "./ConfirmModal2.vue?vue&type=script&lang=js"
export * from "./ConfirmModal2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports